var antlr4 = require('antlr4/index');
var FuncLexer = require('./parsers/generated/FuncLexer');
var FuncParser = require('./parsers/generated/FuncParser');
var FuncDSLGenerator = require('./parsers/FuncDSLGenerator').FuncDSLGenerator;

module.exports = {
  create: (modifierStr) => {
    return new TransformDecomposer(modifierStr);
  },
};

function TransformDecomposer(modifierStr) {
  this._modifierStr = modifierStr;
  this._buildModifierObject();
}

TransformDecomposer.prototype._buildModifierObject = function () {
  var chars = new antlr4.CharStreams.fromString(this._modifierStr); //new antlr4.InputStream(this._modifierStr);
  var lexer = new FuncLexer.FuncLexer(chars);
  var tokens = new antlr4.CommonTokenStream(lexer);
  var parser = new FuncParser.FuncParser(tokens);

  parser.buildParseTrees = true;
  var tree = parser.func();

  var dsl = new FuncDSLGenerator();
  antlr4.tree.ParseTreeWalker.DEFAULT.walk(dsl, tree);
  this._modifierObject = dsl.getFuncDSLObject();
};

TransformDecomposer.prototype.getModifierObject = function () {
  return this._modifierObject;
};

TransformDecomposer.prototype.getModifierJSON = function () {
  return JSON.stringify(this._modifierObject);
};
